import React from 'react'
import { constructUrl } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'
import Link from '../link/Link'

const RelatedFileItem = ({ block }) => {
    const blockTitle = block.childrens.filter((child) => child.block === 'Titre')
    return (
        <Link url={constructUrl(block?.attributes.ID, block?.attributes?.audience)}>
            <span>{icon('arrow-right')}</span>
            <Parser content_block={blockTitle} />
        </Link>
    )
}

export default RelatedFileItem
